// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__bfeJ_","langContainer":"styles_langContainer__Kg8PR","langSet":"styles_langSet__bGv6h"};